<template>
  <div>
    <p v-for="i in [3,1,-2,-3]" class="mb-0">{{ (stats1[i]?.total ?? 0) > (stats2[i]?.total ?? 0) ? '<<' : '==' }}<span
      :class="{'badge': true, 'badge-success': i === 3, 'badge-info': i === 1, 'badge-warning': i < 0}">{{
        Math.round(Math.abs((stats1[i]?.total ?? 0) - (stats2[i]?.total ?? 0)) * 10) / 10
      }}</span>{{ (stats1[i]?.total ?? 0) > (stats2[i]?.total ?? 0) ? '==' : '>>' }}
    </p>
  </div>
</template>

<script>

export default {
  props: ['stats1', 'stats2']
}

</script>
